{
  "create_customer_organization": "Create customer",
  "nextButton": "Next",
  "goBackButton": "Go back",
  "save_and_create_service_btn": "Save and create service",
  "cancel_btn": "Cancel",
  "save_btn": "Save",
  "onboarding": {
    "incomplete": "Onboarding incomplete",
    "incomplete_info_not_activated": "This customer's administrator account(s) are not activated yet.",
    "incomplete_info_no_administrators": "No administrator account(s) have been added to this customer yet",
    "complete": "Onboarding complete"
  },
  "stepper": {
    "selectRegion": "Select region",
    "createCustomer": "Enter details",
    "inviteAdministrators": "Invite administrators"
  },
  "errors": {
    "initial_fetch_error": "Something went wrong. (Fetching customer organization or customer organization related data failed)"
  },
  "usersAdminList": {
    "searchUsersTitle": "Search for users",
    "searchUsersPlaceholder": "Name, email or phone number..."
  },
  "notifications": {
    "error_validation": "It seems that there are errors in the details provided",
    "successful_create": "Customer organization created successfully",
    "successful_update": "Customer organization updated successfully",
    "error_create": "Creating a customer organization failed",
    "error_update": "Updating a customer organization failed",
    "error_pim_organization_no": "Error while fetching Norwegian organization, please try again later"
  },
  "countries": {
    "Finland": "Finland",
    "Norway": "Norway",
    "Sweden": "Sweden",
    "Denmark": "Denmark",
    "UnitedKingdom": "United Kingdom"
  },
  "company_information": {
    "company_information": "Company information",
    "party_id_input_label": "PIM Party ID",
    "tscid_input_label": "TSCID",
    "tscid_input_required_error": "TSCID required",
    "tscid_input_invalid_error": "TSCID can only consist of upper and lower case letters between a-z, numbers between 0-9 and hyphens -",
    "company_name_input_label": "Company name",
    "company_name_input_required_error": "Company name required",
    "customer_business_id_input_label": "Customer business ID",
    "customer_business_id_input_required_error": "Customer business ID required",
    "customer_vat_id_input_label": "Customer VAT ID",
    "customer_vat_id_input_required_error": "Customer VAT ID required",
    "telia_finance_call_off_number_input_label": "Telia Finance call off number",
    "telia_finance_call_off_number_input_required_error": "Telia Finance call off number required",
    "technical_contact_email_input_label": "Technical contact email",
    "technical_contact_email_input_invalid_error": "Invalid email address",
    "region_configuration_input_label": "Region configuration",
    "region_norway_label": "Norway",
    "region_finland_label": "Finland",
    "region_sweden_label": "Sweden",
    "order_channel_input_label": "Order channel",
    "sorvi_id_input_label": "Sorvi ID",
    "sorvi_id_required_error": "Sorvi ID required"
  },
  "parent_organization": {
    "parent_organization": "Parent company",
    "info_text": "If {{editingOrganization}} is owned by another company, and admin users in that company should be able to administer it, select the parent here.",
    "parent_organization_input_label": "Parent company",
    "helper_text": "Admin users in {{parentOrganization}} (and its parents, if any) can administer {{editingOrganization}}.",
    "unlink": "Clear parent",
    "api_error": "Select a different parent company or clear the parent selection. Check the parent of the other company."
  },
  "billing_information": {
    "billing_information": "Billing information",
    "billing_address": "Billing address",
    "billing_contact_person": "Billing contact",
    "first_name_input_label": "First name",
    "first_name_input_required_error": "First name required",
    "last_name_input_label": "Last name",
    "last_name_input_required_error": "Last name required",
    "phone_number_input_label": "Phone number",
    "country_calling_code_input_required_error": "Country calling code required",
    "phone_number_input_required_error": "Phone number required",
    "email_input_label": "Email address",
    "invalid_email_error": "Invalid email address",
    "email_input_required_error": "Email required",
    "address1_input_label": "Additional address information",
    "address2_input_label": "Additional address information (continued)",
    "street_input_label": "Street address or P.O. box",
    "street_input_required_error": "Street address or P.O. box required",
    "city_input_label": "City",
    "city_input_required_error": "City required",
    "zip_input_label": "Postal code",
    "zip_input_required_error": "Postal code required",
    "country_input_dropdown_label": "Country",
    "country_input_required_error": "Country required"
  },
  "device_enrollment": {
    "device_enrollment": "Device enrolment",
    "device_enrollment_info": "Changes made here will only affect future device orders.",
    "apple_enrollment_input_label": "Apple enrolment ID",
    "samsung_enrollment_input_label": "Samsung KNOX enrolment ID"
  },
  "sales_channel": {
    "sales_channel": "Sales channel",
    "sales_channel_info": "Configuration based on your region setting.",
    "sales_channel_input_label": "Sales channel",
    "sales_channel_input_required_error": "Sales channel required",
    "pims_info": "Sales channel details and configuration is in the PIMS system."
  },
  "invite_admin": {
    "email_address_input_label": "Email address",
    "email_address_input_required_error": "Email address required",
    "email_address_invalid_error": "Invalid email address",
    "phoneNumberInputLabel": "Phone number",
    "phoneNumberInputRequiredError": "Phone number required",
    "procurement_limit": "Hide devices priced over ({{currency}}/month, excl. VAT)",
    "procurement_limit_invalid_error": "Has to consist of numbers with maximum two decimals and separated with dot",
    "procurement_limit_additional_text_part1": "If not specified then",
    "procurement_limit_additional_text_part2": "user group has default limit of",
    "group_input_label": "User group",
    "group_input_placeholder": "Select from existing groups",
    "groupRequiredError": "User group required",
    "create_new_group_btn": "Create a new group"
  },
  "administrators": {
    "administratorsHeading": "Administrators",
    "addAdministratorButton": "Add administrator",
    "accountNotActivatedBadge": "Account not activated",
    "editButton": "Edit",
    "doneButton": "Done",
    "cancelButton": "Cancel"
  },
  "createGroupModalDialog": {
    "title": "Create new user group",
    "text": "This will create a new user group for the admin user.",
    "groupNameInputLabel": "Group name",
    "groupNameInputRequiredError": "Group name required",
    "userRolesLabel": "User rights",
    "acceptButton": "Create user group",
    "closeButton": "Cancel"
  },
  "end_of_lease": {
    "end_of_lease": "End of lease options",
    "eol_return": "Return the device and end the lease period",
    "eol_extension": "Extend the lease period",
    "eol_buyout": "Purchase the device and end the lease period"
  },
  "device_limit": {
    "device_limit": "Limit number of devices",
    "limit_to_one_device": "Limit non-admin users to 1 device each"
  },
  "company_device_policy": {
    "company_device_policy": "Company device policy",
    "paragraph1": "To ask all users to read and accept a company device policy, paste the link to your policy here.",
    "paragraph2": "When a user logs in for the first time, they will be shown a page with this link and a button \"I accept\".",
    "company_device_policy_input_label": "Policy URL",
    "company_device_policy_input_error": "Company device policy URL must start with \"https://\""
  },
  "customerCreated": {
    "heading": "Customer created",
    "createdText": "The Common Daas profile has been created for this customer and invitations have been sent to the administrators.",
    "editText": "You can edit the customer settings by signing in with the TSCID, if needed.",
    "backToFrontPageButton": "Back to front page"
  },
  "users": {
    "headers": {
      "name": "Name",
      "userGroup": "User group",
      "status": "Status"
    },
    "activeUser": "Active",
    "inactiveUser": "Inactive",
    "showUserButton": "Show",
    "fetchFailedErrorMessage": "Fetching users failed",
    "noUsersMessage": "No users"
  },
  "userPage": {
    "userFetchFailedErrorMessage": "User was not found",
    "userSavingFailedErrorTitle": "Save failed",
    "userSavingFailedErrorMessage": "Please try again later.",
    "backToUsersLink": "Back to users list",
    "backToGroupLink": "Back to group",
    "orderOnBehalfTitle": "Order device",
    "orderOnBehalfInfo": "You can order a device on behalf of a user provided the user has not not reached the purchase limits.",
    "orderOnBehalfDeviceLimitFull": "User device limit full",
    "initiateOrderOnBehalfFlow": "Order device for user",
    "initiateOrderOnBehalfFlowError": "Failed to start device ordering process",
    "moveUserButton": "Change user group",
    "deleteUserButton": "Delete user",
    "offboardUserButton": "Offboard user",
    "notOnboarded": "Not onboarded",
    "phoneNumberNotVerified": "Phone number not verified",
    "moveUserModal": {
      "title": "Change user group",
      "description": "Select a new user group.",
      "targetGroupLabel": "New user group",
      "noOtherGroups": "No other user groups are available.",
      "fetchGroupsError": "Could not load user groups.",
      "moveButton": "Save changes",
      "cancelButton": "Cancel"
    },
    "deleteUserModal": {
      "title": "Delete user confirmation",
      "confirmationText": "Are you sure that you want to delete this user?",
      "inactiveUser": "<Inactive user>",
      "name": "Name: {{name}}",
      "email": "Email: {{email}}",
      "phoneNumber": "Phone number: {{phoneNumber}}",
      "deleteButton": "Delete",
      "cancelButton": "Cancel"
    },
    "deleteUserApiErrorMessagePrefix": "Deleting user failed:",
    "deleteUserGenericApiErrorMessage": "Deleting user failed for unknown reason.",
    "moveUserApiErrorMessagePrefix": "Changing user group failed:",
    "moveUserGenericApiErrorMessage": "Changing user group failed for unknown reason.",
    "ProfileCard": {
      "title": "Profile",
      "name": "Name",
      "employeeGroup": "User group",
      "email": "Email address",
      "phoneNumber": "Phone number",
      "employeeId": "Employee ID",
      "preScheduledOnboardingTitle": "Onboarding date",
      "preScheduledOnboardingDescription": "The employee will be granted access to the portal and receive a welcome e-mail to select their device on the selected date.",
      "offboardingTitle": "Offboarding",
      "offboardingLabel": "Offboarding started",
      "offboardingDescription": "The user is leaving the organization. Depending on the role, logging in is allowed for device management. Ordering new devices is blocked. The account will be automatically deleted once all devices have been deactivated or reassigned.",
      "offboardingDateInvalid": "Please enter a valid offboarding date",
      "offboardingDateNotSelected": "Offboarding start date is not selected",
      "offboardingCancel": "Cancel offboarding",
      "offboardingCancelled": "Offboarding cancelled",
      "pimPartyIdTitle": "PIM party ID",
      "inactiveUser": "Inactive user",
      "companyDevicePolicyTitle": "Company device policy",
      "companyDevicePolicyIsAccepted": "User has Accepted",
      "companyDevicePolicyIsNotAccepted": "User has not accepted yet",
      "companyDevicePolicyNotApplicable": "Policy created after user activation",
      "disabledEmailText": "Email change disabled for user without BankID",
      "validEmailNotification": "Please enter valid email.",
      "validPhoneNumberNotification": "Please enter valid phone number.",
      "validCountryCodeNotification": "Please enter valid country code.",
      "phoneNumberRequiredNotification": "Phone number required.",
      "countryCodeRequiredNotification": "Country code required.",
      "phoneNumberVerificationNotificationTitle": "Confirmation needed",
      "phoneNumberVerificationNotificationMessage": "New phone number will require confirmation from user.",
      "saveButton": "SAVE CHANGES",
      "cancelButton": "CANCEL"
    },
    "userRightsAndLimitsCard": {
      "mainTitle": "User rights and limits",
      "userRightsTitle": "User rights",
      "userRightsText": "Some selections are copied from the settings under \"User groups\" and will not be overruled from here",
      "allowAccessWithoutBankIdTitle": "Login",
      "allowAccessWithoutBankIdText": "If the user do not have BankID, you can provide access to the portal without using BankID.",
      "allowAccessWithoutBankIdLabel": "Allow access without BankID",
      "procurementLimitTitle": "Limit visibility in shop",
      "procurementLimitInputLabel": "Hide devices priced over ({{currency}}/month, excl. VAT)",
      "procurementLimitOverrideCheckboxLabel": "Override inherited",
      "procurementLimitRequiredError": "Maximum price required",
      "procurementLimitNumberRequirdError": "Only numerical value accepted",
      "allowanceTitle": "Max price/device paid by employer",
      "allowanceExplanation": "If this user selects a device that costs more, the difference is deducted from their salary.",
      "allowanceInputLabel": "Max price/device paid by employer ({{currency}}/month, incl. VAT)",
      "allowanceInputLabelOneTime": "Max price/device paid by employer ({{currency}}, incl. VAT)",
      "allowanceUnlimited": "unlimited",
      "allowanceEditLinkTo": "Allowance settings can be edited in",
      "minBedriftLinktext": "Min Bedrift",
      "saveButton": "SAVE CHANGES",
      "cancelButton": "CANCEL"
    },
    "assets": {
      "title": "Devices",
      "noAssets": "User has no devices.",
      "endDate": "End date"
    },
    "offboardUserModal": {
      "title": "Offboard user",
      "description": "What happens on the offboarding start date?",
      "name": "Name",
      "inactiveUser": "Inactive user",
      "email": "Email",
      "phoneNumber": "Phone number",
      "devices": "Active devices",
      "imei": "IMEI",
      "endDate": "End date",
      "dateLabel": "Select offboarding start date",
      "invalidDate": "Invalid date",
      "allowedActions": "Depending on the role, logging in is allowed for device management.",
      "blockedActions": "Ordering new devices is blocked.",
      "automaticActions": "On or after the offboarding start date, the account will be automatically deleted as soon as all devices have been deactivated or reassigned.",
      "additionalNote": "Please note: Any active orders or pending approvals will block the deletion until they are resolved.",
      "notificationTitle": "Important Admin Responsibility",
      "notificationMessage": "If a device's lease period is still ongoing, or if the user fails to choose an option at the end of the lease, the administrator must manage and resolve the device's status manually.",
      "offboardButton": "Offboard",
      "cancelButton": "Cancel",
      "confirmationModal": {
        "title": "Are you sure you want to proceed?",
        "confirmInfo": "Please note that admin has the final responsibility for deactivating or reassigning of the device if the lease period is still ongoing or the user does not take an action.",
        "confirmButton": "Confirm",
        "cancelButton": "Cancel"
      },
      "errorMessage": "Something went wrong. Please try again later."
    }
  },
  "inviteUserModal": {
    "inviteUserButton": "Invite user",
    "assignToUserGroup": "Assign to user group",
    "email": "Email address",
    "phoneNumber": "Phone number",
    "employeeId": "Employee ID",
    "saveButton": "Invite user",
    "cancelButton": "CANCEL",
    "inviteUser": "Invite user",
    "required": "required",
    "fieldRequired": "Field required",
    "invalidEmail": "Invalid email address",
    "invalidPhoneNumber": "Invalid phone number",
    "saveErrorTitle": "Error",
    "saveErrorMessage": "Saving user failed",
    "purchaseLimitsTitle": "Purchase limits",
    "purchaseLimitsDescription": "Default rules are inherited from the user group. Here you can override the rules for this user.",
    "limitVisibilityTitle": "Limit visibility in shop",
    "overrideVisibilityCheckboxLabel": "Override inherited",
    "maxPricePerProductInputLabel": "Hide devices priced over ({{currency}}/month, excl. VAT)",
    "noVisibilityRestrictionMessage": "This user can see all products in the shop.",
    "restrictedVisibilityMessage": "This user can only see and order products with price up to",
    "restrictedVisibilityMessageEnding": "in the shop.",
    "monthShort": "mon",
    "subscriptionLimitsTitle": "Limits for subscription products",
    "limitSubscriptionCheckBoxLabel": "Limit user to 1 subscription product",
    "enabledSingleDevicePolicyMessage": "This user can have only one subscription product at a time.",
    "disabledSingleDevicePolicyMessage": "This user can have multiple subscription products.",
    "procurementLimitTypeError": "Invalid input. Please enter the sum in form x or x.xx.",
    "invoicingAccount": {
      "title": "Invoicing account",
      "dropdownLabel": "Current invoicing account",
      "clearSelection": "Clear selection",
      "userGroupNotSelected": "User group not selected",
      "noOptionsFoundInfo": "No invoicing account options found"
    },
    "showExpanderButton": "Show",
    "hideExpanderButton": "Hide"
  },
  "regionSelection": {
    "title": "Region",
    "businessIdInputLabel": "Customer Business ID",
    "businessIdNotFoundNorwayError": "Business ID does not match any organizations in Norway.",
    "businessIdAlreadyExistsError": "Organization already exists."
  }
}
